export default __webpack_public_path__ + "static/media/github.5bc18972.svg";